import BaseProxy from '../../proxies/Proxy'

class OffersProxy extends BaseProxy {
  static company_id;

  /**
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    parameters.client = "front";
    super(`companies/${OffersProxy.company_id}/offers`, parameters);
  }
}

export default OffersProxy;
